import { ApolloClient, ApolloLink, HttpLink, InMemoryCache } from "@apollo/client";
import { onError } from "@apollo/client/link/error";
import { RetryLink } from "@apollo/client/link/retry";
import config from "../config/env";
import { reportError } from "../utils/errorUtils";

const retryLink = new RetryLink({
  delay: {
    initial: 500,
    max: 30000,
    jitter: true
  },
  attempts: {
    max: 10,
    retryIf: (_error, operation) =>
      Boolean(operation?.query?.definitions?.length) && operation.query.definitions[0]?.kind === "OperationDefinition"
        ? operation.query.definitions[0].operation === "query"
        : false
  }
});

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, locations, path }) => {
      reportError(
        `[Screener GraphQL error]: Message: ${message}, Location: ${JSON.stringify(locations)}, Path: ${path}`
      );
    });
  }
  if (networkError) {
    reportError(`[Screener Network error]: ${networkError}`);
  }
});

const screenerClient = new ApolloClient({
  link: ApolloLink.from([
    retryLink,
    errorLink,
    new HttpLink({
      uri: config.env.REACT_APP_GRAPHQL,
      credentials: "omit"
    })
  ]),
  cache: new InMemoryCache()
});

export default screenerClient;
